/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssessmentProgressResponse
 */
export interface AssessmentProgressResponse {
    /**
     * 
     * @type {number}
     * @memberof AssessmentProgressResponse
     */
    assessmentProgressPercent?: number;
}

/**
 * Check if a given object implements the AssessmentProgressResponse interface.
 */
export function instanceOfAssessmentProgressResponse(value: object): value is AssessmentProgressResponse {
    return true;
}

export function AssessmentProgressResponseFromJSON(json: any): AssessmentProgressResponse {
    return AssessmentProgressResponseFromJSONTyped(json, false);
}

export function AssessmentProgressResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssessmentProgressResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'assessmentProgressPercent': json['assessmentProgressPercent'] == null ? undefined : json['assessmentProgressPercent'],
    };
}

export function AssessmentProgressResponseToJSON(json: any): AssessmentProgressResponse {
    return AssessmentProgressResponseToJSONTyped(json, false);
}

export function AssessmentProgressResponseToJSONTyped(value?: AssessmentProgressResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assessmentProgressPercent': value['assessmentProgressPercent'],
    };
}

